import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import Logo from "../../assets/Logo-white.svg";
import { Link } from "react-router-dom";
import { Button } from "../typography/button.component";
import { Spacer } from "../spacer/spacer.component";
import Fb from "../../assets/facebook.svg";
import X from "../../assets/x.svg";
import Ig from "../../assets/instagram.svg";
import Yt from "../../assets/tiktok.svg";
import Process from "../../assets/SpinnerGap.svg";
import { useTranslation } from "react-i18next";

/*for firebase config, remove after done with it*/
import { db } from "../../temporal/firebase";
import {
  collection,
  addDoc,
  setDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";

const FooterContainerWrapper = styled.div`
  width: 100%;
  background-color: rgba(29, 109, 193, 1);
  color: #fff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;
const FooterContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  display: flex;
  justify-content: space-between;
  padding: 64px 0;
  @media (max-width: 1448px) {
    justify-content: space-around;
  }
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`;
const FooterDesc = styled.div`
  width: 100%;
  max-width: calc(100% / 4);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
    max-width: 80%;
  }
`;
const FooterLogoWrapper = styled.figure`
  max-width: 100px;
  max-height: 100px;
`;
const FooterLogo = styled.img`
  max-width: 100%;
  max-height: 100%;
`;
const FooterDescPara = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 25px;
  letter-spacing: 0%;
  padding: 16px 0;
  @media (max-width: 480px) {
    text-align: center;
    font-size: 12px;
  }
`;
const FooterServicesCompanyLegalWrapper = styled.div`
  width: 100%;
  max-width: calc(100% / 4);
  display: flex;
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
    max-width: 100%;
    padding-top: 18px;
  }
`;
const FooterSCLWrapper = styled.div`
  padding: 0 24px;
`;
const FooterSCLHeading = styled.h3`
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;

  @media (max-width: 480px) {
    font-size: 24px;
    padding-top: 18px;
  }
`;
const FooterSCLParaNotAllowed = styled(Link)`
  cursor: not-allowed;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  display: block;
  text-decoration: none;
  color: #fff;
  padding-top: 12px;

  position: relative;
  &:hover {
    cursor: not-allowed;
  }
//   &::after {
//     content: "";
//     position: absolute;
//     height: 3px;
//     background-color: #fff;
//     width: 0;
//     bottom: -3px;
//     align-self: center;
//     right: 0;
//     transition: all 300ms ease;
//   }
//   &:hover::after {
//     width: 100%;
//     left: 0;
//   }
  @media (max-width: 480px) {
    font-size: 14px;
    padding-top: 18px;
  }
`;
const FooterSCLPara = styled(Link)`
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  display: block;
  text-decoration: none;
  color: #fff;
  padding-top: 12px;

  position: relative;
  &:hover {
    cursor: pointer;
  }
//   &::after {
//     content: "";
//     position: absolute;
//     height: 3px;
//     background-color: #fff;
//     width: 0;
//     bottom: -3px;
//     align-self: center;
//     right: 0;
//     transition: all 300ms ease;
//   }
//   &:hover::after {
//     width: 100%;
//     left: 0;
//   }
  @media (max-width: 480px) {
    font-size: 14px;
    padding-top: 18px;
  }
`;
const FooterNewsletterSubWrapper = styled.form`
  width: 100%;
  max-width: calc(100% / 4);
  padding: 0 32px;
  @media (max-width: 480px) {
    font-size: 16px;
    padding-top: 24px;
    max-width: 100%;
  }
`;
const FooterNewsletterHeading = styled.h3`
  font-size: 16px;
  @media (max-width: 480px) {
    font-size: 24px;
    padding-top: 24px;
    max-width: 100%;
  }
`;
const FooterNewsletterPara = styled.p`
  padding: 12px 0;
  line-height: 25px;
  @media (max-width: 480px) {
    font-size: 12px;
  }
`;
const FooterNewsletterInput = styled.input`
  font-size: 14px;
  border-radius: 4px;
  padding: 6px 12px;
  outline: none;
  border: 1px solid lightgray;
  width: 100%;
  @media (max-width: 480px) {
    font-size: 18px;
    padding: 8px 12px;
    max-width: 100%;
  }
`;
const FooterAddressWrapper = styled.div`
  max-width: calc(100% / 4);
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 480px) {
    padding-top: 32px;
    max-width: 100%;
  }
`;
const Address = styled.div`
  padding: 12px 12px;
`
const Phone = styled.p`
  padding-top: 12px;
`
const FooterSocialMediaLinks = styled.div`
  max-width: 100%;
  display: flex;
`;
const FooterSocialMediaLinkWrapper = styled.figure`
  padding: 0 12px;
  display: flex;

  @media (max-width: 480px) {
    width: 72px;
    height: 72px;
    justify-content: center;
    align-items: center;

    padding: 0 12px;
  }
`;
const FooterSocialMediaLink = styled.img`
  width: 100%;

  &:hover {
    opacity: 0.6;
    transition: 400ms;
    cursor: pointer;
  }
`;
const Copyright = styled.p`
  padding: 32px 0;
`;
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
const ProcessImage = styled.img`
  width: 100%;
  max-width: 24px;
  max-height: 24px;
  font-weight: 700;
  height: 100%;
  filter: invert(1);
  animation: ${spin} 1s linear infinite;
`;

export const Footer = ({ setModalOpen = false }) => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState("");
  const [error, setError] = useState("");
  const [isProcessing, setIsprocessing] = useState(false);
  const { t } = useTranslation();

  const submit = async (e) => {
    e.preventDefault();
    setIsprocessing(true);
    setError("");
    setDone("");

    try {
      await setDoc(doc(db, "newsletter", email), {
        email,
        createdAt: serverTimestamp(),
      });

      setDone(t('footer.subscribe-success') + " 😊");
    } catch (err) {
      setDone(('footer.subscribe-already') + " 😊");
      console.error(err.code);
    }
    setEmail("");
    setIsprocessing(false);
  };
  return (
    <FooterContainerWrapper>
      <FooterContainer>
        <FooterDesc>
          <FooterLogoWrapper>
            <FooterLogo src={Logo} alt="" />
          </FooterLogoWrapper>
          <FooterDescPara>
            {t('footer.description')}
          </FooterDescPara>
          <Button
            size={"small"}
            variant="option2"
            backgroundcolor="#fff"
            color="rgba(29, 109, 193, 1)"
            onClick={() => setModalOpen(true)}
          >
            {t('footer.waitlist-btn')}
          </Button>
        </FooterDesc>
        <FooterServicesCompanyLegalWrapper>
          <FooterSCLWrapper>
            <FooterSCLHeading>{t('footer.services-title')}</FooterSCLHeading>

            <FooterSCLPara as="a" href="#services">
              {t('footer.service-1')}
            </FooterSCLPara>

            <FooterSCLPara as="a" href="#services">
              {t('footer.service-2')}
            </FooterSCLPara>

            <FooterSCLPara as="a" href="#services">
              {t('footer.service-3')}
            </FooterSCLPara>

            <FooterSCLPara as="a" href="#services">
              {t('footer.service-4')}
            </FooterSCLPara>

            <FooterSCLPara as="a" href="#services">
              {t('footer.service-5')}
            </FooterSCLPara>

            <FooterSCLPara as="a" href="#services">
              {t('footer.service-6')}
            </FooterSCLPara>
          </FooterSCLWrapper>
          <FooterSCLWrapper>
            <FooterSCLHeading>{t('footer.company-title')}</FooterSCLHeading>

            <FooterSCLPara as="a" href="#about-us">
              {t('footer.company-1')}
            </FooterSCLPara>

            <FooterSCLParaNotAllowed>{t('footer.company-2')}</FooterSCLParaNotAllowed>

            <FooterSCLParaNotAllowed>{t('footer.company-3')}</FooterSCLParaNotAllowed>

            <FooterSCLParaNotAllowed>{t('footer.company-4')}</FooterSCLParaNotAllowed>

            <FooterSCLParaNotAllowed>{t('footer.company-5')}</FooterSCLParaNotAllowed>
          </FooterSCLWrapper>

          {/* <FooterSCLWrapper>
            <FooterSCLHeading>Legal</FooterSCLHeading>

            <FooterSCLParaNotAllowed>
              Terms
            </FooterSCLParaNotAllowed>

            <FooterSCLParaNotAllowed >
              Privacy
            </FooterSCLParaNotAllowed>

            <FooterSCLParaNotAllowed >
              Security
            </FooterSCLParaNotAllowed>
          </FooterSCLWrapper> */}
        </FooterServicesCompanyLegalWrapper>
        <FooterNewsletterSubWrapper onSubmit={submit}>
          <FooterNewsletterHeading>
            {t('footer.newsletter-title')}
          </FooterNewsletterHeading>
          <FooterNewsletterPara>
            {t('footer.newsletter-desc')}
          </FooterNewsletterPara>
          <Spacer size="large">
            <FooterNewsletterInput
              required
              type="email"
              placeholder={t('footer.newsletter-placeholder')}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Spacer>
          {done}
          <Spacer size="large">
            <Button
              size={"small"}
              variant="option2"
              backgroundcolor="#fff"
              color="rgba(29, 109, 193, 1)"
            >
              {isProcessing ? <ProcessImage src={Process} /> : t('footer.newsletter-btn')}
            </Button>
          </Spacer>
        </FooterNewsletterSubWrapper>
        <FooterAddressWrapper>
          <FooterSocialMediaLinks>
            <FooterSocialMediaLinkWrapper>
              <Link
                target="_blank"
                to={
                  "https://www.facebook.com/people/Kanasant%C3%A9/61585401757337/"
                }
              >
                <FooterSocialMediaLink src={Fb} alt="facebook" />
              </Link>
            </FooterSocialMediaLinkWrapper>
            <FooterSocialMediaLinkWrapper>
              <Link target="_blank" to={"https://x.com/Kanasante"}>
                <FooterSocialMediaLink src={X} alt="x" />
              </Link>
            </FooterSocialMediaLinkWrapper>
            <FooterSocialMediaLinkWrapper>
              <Link
                target="_blank"
                to={"https://www.instagram.com/kanasanteapp"}
              >
                <FooterSocialMediaLink src={Ig} alt="instagram" />
              </Link>
            </FooterSocialMediaLinkWrapper>
            <FooterSocialMediaLinkWrapper>
              <Link target="_blank" to={"https://www.tiktok.com/@kanaSante"}>
                <FooterSocialMediaLink src={Yt} alt="youtube" />
              </Link>
            </FooterSocialMediaLinkWrapper>
          </FooterSocialMediaLinks>
          <Address>
            <p>7 rue guy, Saint Constant (Apt: 1405), J5A 1A7</p>
            <Phone>+1 (514) 235-8996</Phone>
          </Address>
        </FooterAddressWrapper>
      </FooterContainer>
      <Copyright>Copyright @KanaSanté {new Date().getFullYear()}</Copyright>
    </FooterContainerWrapper>
  );
};
